import React from "react";

type StaffHeadingProps = {
  staffName: string;
  initials: string;
  leaid: string;
  school: string;
  seid: string;
  localId: string;
  primaryRole?: string;
};

export default function StaffHeading({
  staffName,
  initials,
  leaid, // still here in case you need it later
  school,
  seid,
  localId,
  primaryRole,
}: StaffHeadingProps) {
  return (
    <div className="d-flex flex-column gap-2 w-100">
      <div
        className="card mb-0 border-0 rounded-4 w-100"
        style={{ boxShadow: "none" }}
      >
        <div className="card-body px-3 py-3">
          <div className="row align-items-center">
            <div className="col-md-6 d-flex align-items-center gap-3">
              <div
                className="d-flex justify-content-center align-items-center rounded-4 text-white card-custom"
                style={{
                  width: "64px",
                  height: "64px",
                  background:
                    "linear-gradient(135deg, #003a5d 0%, #00527e 100%)",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                }}
              >
                {initials.toUpperCase()}
              </div>

              <div>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span
                    className="fw-bold text-uppercase"
                    style={{
                      fontSize: "0.9rem",
                      lineHeight: 1,
                      letterSpacing: ".5px",
                    }}
                  >
                    Staff Record
                  </span>
                </div>

                <h1 className="fw-bold mb-0" style={{ fontSize: "1.6rem" }}>
                  {staffName}
                </h1>

                {primaryRole && <div className="text-muted">{primaryRole}</div>}
              </div>
            </div>

            <div
              className="col-md-6 text-md-end mt-3 mt-md-0"
              style={{ fontSize: "1.1rem", lineHeight: "1.5" }}
            >
              <div className="mb-1">
                <span className="fw-bold">SEID:</span> {seid || "-"}
              </div>
              <div>
                <span className="fw-bold">Staff Local ID:</span> {localId}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
